// import { test, enforce, create } from 'vest'
// import { triageLevelStates } from '../../../store/reports/types'

// export const formValidation = create((data = {}) => {
//   const {
//     triageLevel,
//     issueDescription,
//     response,
//     userMessage,
//     selectedUsers,
//     message,
//     investigator,
//   } = data

//   test('triageLevel', 'Triage level must be selected', () => {
//     enforce(triageLevel).isNotEmpty()
//   })

//   if (triageLevel === triageLevelStates.ADDRESSED_AND_RESOLVED) {
//     test('issueDescription', 'Issue Description can not be empty', () => {
//       enforce(issueDescription).isNotEmpty()
//     })
//     test('response', 'Response can not be empty', () => {
//       enforce(response).isNotEmpty()
//     })
//   }

//   if (triageLevel === triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED) {
//     test('investigator', 'You must select at least one user!', () => {
//       enforce(investigator).isNotEmpty()
//     })
//     test('message', 'Message can not be empty', () => {
//       enforce(message).isNotEmpty()
//     })
//   }

//   if (triageLevel === triageLevelStates.TRANSFERED_FOR_ASSIGNMENT) {
//     test('investigator', 'You must select at least one user!', () => {
//       enforce(investigator).isNotEmpty()
//     })
//   }
// })


import { test, enforce, create, skipWhen } from 'vest'
import { triageLevelStates } from '../../../store/reports/types'

export const formValidation = create((data = {}) => {
  const {
    triageLevel,
    issueDescription,
    response,
    // userMessage,
    message,
    investigator,
  } = data

  // Always run triageLevel test
  test('triageLevel', 'Triage level must be selected', () => {
    enforce(triageLevel).isNotEmpty()
  })

  // Issue Description
  test('issueDescription', 'Issue Description can not be empty', () => {
    skipWhen(triageLevel !== triageLevelStates.ADDRESSED_AND_RESOLVED, () => {
      enforce(issueDescription).isNotEmpty()
    })
  })

  // Response
  test('response', 'Response can not be empty', () => {
    skipWhen(triageLevel !== triageLevelStates.ADDRESSED_AND_RESOLVED, () => {
      enforce(response).isNotEmpty()
    })
  })

  // Investigator
  test('investigator', 'You must select at least one user!', () => {
    skipWhen(
      ![triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED, triageLevelStates.TRANSFERED_FOR_ASSIGNMENT].includes(triageLevel),
      () => {
        enforce(investigator).isNotEmpty()
      }
    )
  })

  // Message
  test('message', 'Message can not be empty', () => {
    skipWhen(triageLevel !== triageLevelStates.IMMEDIATE_ATTENTION_REQUIRED, () => {
      enforce(message).isNotEmpty()
    })
  })
})
